import e from"./mixins.js";import{theSamePair as r,lngLat2Array as t,nearPair as s}from"../utils/amap-helpers.js";import{defineProp as i}from"./props.js";import{plane as p}from"./geometry.js";var o=e(p).extend({props:{center:i({type:Array,clone:!0,deep:!0,equals:r,setter:function(e,r){if(r){if(this.$props.draggable||this.$props.editable){var i=t(e.getCenter());if(s(r,i))return}e.setCenter([r[0],r[1]])}},getter:function(e){var r=e.getCenter();return t(r)},events:["dragging","dragend"]}),radius:i({type:Number,setter:"setRadius"})}});export default o;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/mixins/circle.js
// module id = null
// module chunks = 